export *from './news.component';


// WEBPACK FOOTER //
// ./app/insa-components/insa-news/index.ts